import router from "../router/index";
import { getToken, isLogged } from "./auth";
import axios from "axios";

const service = axios.create({
  baseURL: 'https://tapegypt.com/api', // Use `import.meta.env` for Vite
  // baseURL: process.env.VUE_APP_BASE_URL, // Use this for Vue CLI
  timeout: 10000, // Reasonable timeout (10 seconds)
});

service.interceptors.request.use(
  (config) => {
    if (isLogged()) {
      config.headers["Authorization"] = `Bearer ${getToken()}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error); // Pass the error to the response handler
  }
);

// Response pre-processing
service.interceptors.response.use(
  (response) => {
    return response.data; // Simplify response for convenience
  },
  (error) => {
    const { response } = error;
    if (response) {
      const { status } = response;

      if (status === 401) {
        // Handle unauthorized access
        router.push({ name: "login" });
      } else if (status === 500) {
        console.error("Server error:", response.data || "Unexpected error");
      }
    } else {
      console.error("Network error or no response from server.");
    }
    return Promise.reject(error); // Ensure error propagates
  }
);

export default service;
